// extracted by mini-css-extract-plugin
module.exports = {"markdownModalStyle":"_2jVYSXh_Am1IKluBrYfUwl"};